<template>
    <li v-if="showReminderEmailInformation">
        {{ delayValue }}h {{ $t('coupon.reminderEmail') }} {{ email }}
    </li>
</template>

<script>

export default {
    name: 'coupon-reminder-email',
    props: {
        appointment: { type: Object, required: true },
        confirmation: { type: Object, required: true },
    },
    computed: {
        /**
         * Returns the delay in hours
         */
        delayValue() {
            return this.confirmation.delay / 60;
        },

        /**
         * Return the client email or an empty string
         */
        email() {
            return this.appointment.clientData.email || '';
        },

        /**
         * Validate the display of email information for the reminder
         */
        showReminderEmailInformation() {
            return this.confirmation &&
                this.confirmation.sendEmail &&
                this.appointment.clientData.email;
        },
    },
};
</script>
